import React from 'react';
import { Label, Row, Col, FormGroup, Button, Input } from 'reactstrap';
import '../../configuracao.style.css';
import IntlMessage from '../../../../../src/helpers/intlMessage';

const ConfiguracoesEmailPage = (props) => (
  <div
    style={{
      height: `${props.altura}px`,
      width: '100%',
      overflowY: 'scroll',
      overflowX: 'hidden',
    }}
  >
    <form onSubmit={(e)=> props.salvar(e)}>
    <div className="config-item">
      <Row>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.emailSender"/></Label>
            <Input
              required
              type="email"
              className="borda-arredondada"
              value={props.email}
              onChange={(e) => props.changeEmail(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.password"/></Label>
            <Input
              required
              type="password"
              className="borda-arredondada"
              value={props.password}
              onChange={(e) => props.changePassword(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.smtp"/></Label>
            <Input
              required
              type="text"
              minLength="5"
              className="borda-arredondada"
              value={props.smtp}
              onChange={(e) => props.changeSMTP(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xl={12}>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.door"/></Label>
            <Input
              required
              type="text"
              minLength={2}
              className="borda-arredondada"
              value={props.porta}
              onChange={(e) => props.changePorta(e.target.value)}
            />
          </FormGroup>
        </Col>{' '}
      </Row>
    </div>
    <Button
      className="exame-personalidado-button"
      color="primary"
      type="submit"
    >
      <IntlMessage id = "dashboards.examDetail.save"/>
    </Button>
    </form>
  </div>
);

export default ConfiguracoesEmailPage;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/email/email.page.js